import React from "react";
import MobileMockupImage from "../../assets/images/mobile-mockup.png";
import "./MobileMockup.css";

export default function MobileMockup() {
  return (
    <>
      <div className="mobile">
        <img
          src={MobileMockupImage}
          alt="Mobile Mockup"
          className="mobile-mockup"
        />
        <div className="mobile-content">
          <p className="mobile-text-1">CHAUWK APP : PROGRESS IN LIFE !</p>

          <p className="mobile-text-2">
            Access job opportunities, improve your skills, and connect with a
            supportive community.
          </p>

          <div className="mobile-text-3-p">
            <p>
              Helps build Skilled & Happy and Productive workers!
            </p>
          </div>

          <div className="mobile-text-4">
            <h3>Available on Google Play</h3>
            <p>Download now to start building a brighter future.</p>
          </div>

          <div className="googleplay">
            <a
              href="https://play.google.com/store/apps/details?id=com.varincommunications.chauwk"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="base-floor"></div>
    </>
  );
}
